import * as React from "react";
import {cn} from "@/ReactInit/Scripts/DashboardPage/utils/dashboardHelpers";

interface FormProps {
  onSearch: (searchTerm: string) => void;
  value: string;
  label?: string;
  placeholder?: string;
  legendSize?: 'normal' | 'large';
}

const DashboardSearchInput: React.FC<FormProps> = (
  {
    onSearch,
    value,
    label = "Søk",
    placeholder = "Navn / virksomhet",
    legendSize = 'normal',
  }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  const legendTextSize = legendSize === "large" ? "text-xl tablet:text-2xl" : "text-lg tablet:text-xl";

  return (
    <div className="relative flex flex-col gap-2 w-full">
      <legend className={cn("font-semibold px-1 w-full", legendTextSize)}>
        {label}
      </legend>
      <form onSubmit={handleSubmit}>
        <fieldset className="flex gap-2 relative">
          <label htmlFor="search" className="sr-only">Søk</label>
          <input onChange={handleChange} value={value} type="search" id="search" placeholder={placeholder}
                 name="q"
                 className="w-full py-3 pl-6 pr-[60px] text-lg bg-white border-2 border-brown-primary rounded-xl placeholder-black-text text-black-text truncate"
          />
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
               className="absolute top-3.5 right-6"
          >
            <path
              d="M21 21L16.7 16.7M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
              stroke="#555555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            />
          </svg>
        </fieldset>
      </form>
    </div>
  );
};

export default DashboardSearchInput;
